import { CircularProgress, Table, TableBody, TableCell, TableFooter, TableRow, Tooltip, Typography } from '@mui/material';
import { useData } from "@pure-ptr/react";
import React, { useContext } from 'react';

import { getCasCodesSummary } from "../../store/api/summaryDashboard";
import { asDollarsWithZero } from '../../util/format';
import { DashboardFiltersContext, useClaimAnalysisPage, useStyles } from './Dashboard';


export const CasCodesWidget = () => {
    const classes = useStyles();
    const { dateRange, history } = useContext(DashboardFiltersContext);

    const { data, isPending } = useData( async () => {
        const result = await getCasCodesSummary( dateRange.startdate, dateRange.enddate );
        return result;
    }, [ dateRange ]);

    const getTotalCasCodes = () => {
        let total = data?.slice(0, 10).reduce((sum, item) => sum + (item.amount || 0), 0); 
        return total;
    }

    const openClaimAnalysis = useClaimAnalysisPage();

    const handleCasCodeAmountClick = (ids) => {
        sessionStorage.removeItem("duplicated");

        let filters = [
            {
                actualFilter: true, 
                equator: "equals", 
                field: "reasoncode", 
                value: ids
            }
        ]

        openClaimAnalysis({
            filter: filters,
            customFilter: [
                {
                    customFilter: true, 
                    equator: "greater_than_or_equals_to", 
                    field: "remitdate", 
                    value: dateRange.startdate,
                    relativeFilter: dateRange.relativeFilter

                },
                {
                    customFilter: true, 
                    equator: "less_than_or_equals_to", 
                    field: "remitdate", 
                    value: dateRange.enddate,
                    relativeFilter:dateRange.relativeFilter
                },
               
            ],
            significance: false,
        });
    }

    return isPending ? (
        <CircularProgress />
        ) : (
        <Table stickyHeader>
            <TableBody sx={{paddingLeft: "10px"}}>
            {data?.slice(0, 10)?.map((cas) => (
                <TableRow key={cas.casCode}>
               <TableCell>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "10px" }}>
                <div style={{ width: "50%", wordBreak: "break-word" }}>
                    <Tooltip title={cas.fullDesc}>
                        <Typography variant='body2'>
                            <strong>{cas.casCode}</strong> - {cas.shortDesc}
                        </Typography>
                    </Tooltip>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                    <Typography
                        onClick={() => handleCasCodeAmountClick(cas.casCode)}
                        variant="subtitle1"
                        className={classes.link}
                    >
                        {`${asDollarsWithZero(cas.amount)} (${cas.claimsCount} claims)`}
                    </Typography>
                </div>
            </div>
        </TableCell>
                </TableRow>
            ))}
            </TableBody>
            <TableFooter className={classes.blueBg}>
                <TableRow key={`totalCasCodes`}>
                    <TableCell colSpan={2} sx={{ fontWeight: 800, padding: "10px" }}>
                        <Typography variant='h6'gutterBottom>Total: {asDollarsWithZero(getTotalCasCodes())}</Typography>
                    </TableCell>
                </TableRow>
            </TableFooter>
        </Table>
        )
}